import { render, staticRenderFns } from "./BannerDetail.vue?vue&type=template&id=1c3ac649&scoped=true"
import script from "./BannerDetail.vue?vue&type=script&lang=js"
export * from "./BannerDetail.vue?vue&type=script&lang=js"
import style0 from "./BannerDetail.vue?vue&type=style&index=0&id=1c3ac649&prod&lang=less&scoped=true"
import style1 from "./BannerDetail.vue?vue&type=style&index=1&id=1c3ac649&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ac649",
  null
  
)

export default component.exports